import React from 'react';
import ProductPatternPage from './ProductPatternPage';
import './PapayaPage.css';
import papayaLogo from '../images/papaya-logo.png';

const varieties = [

];

export default function PapayaPage() {
  return <ProductPatternPage title="Papaya" varieties={varieties} pageClass="papaya-page" heroImage={papayaLogo} />;
}
